import { PropsWithChildren } from 'react';

export default function FlexGroup({ children }: PropsWithChildren) {
  return (
    <div className="flex w-full justify-between items-center gap-1">
      {children}
    </div>
  );
}
